import React from "react";
import styled from "styled-components";
import { NavItem } from "components/bootstrap";
import { itemStateIndicatorSelector } from "components/common/NavItemStateIndicator";
const StyledInactiveNav = styled(NavItem)`
  ${itemStateIndicatorSelector} {
    display: none;
  }
`;
const InactiveNavItem = ({
  active: _active = void 0,
  className = void 0,
  children = void 0,
  ...props
}) => /* @__PURE__ */ React.createElement(StyledInactiveNav, { className, ...props }, children);
export default InactiveNavItem;
